import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import snackbar from "app/store/snackbar/snackbar";

export default combineReducers({
  auth,
  message,
  snackbar,

});
